import { FC, PropsWithChildren } from "react";

import { ApiProviderJwt } from "@framework/provider-api-jwt";
import { AsuProvider } from "@framework/provider-asu";
import { UserProviderJwt } from "@framework/provider-user-jwt";
import { SettingsProvider } from "@framework/provider-settings";
import { ThemeProvider } from "@framework/provider-theme";
import { LocalizationProvider } from "@framework/provider-localization";
import { PickerProvider } from "@framework/provider-picker";
import { EnabledLanguages, ns } from "@framework/constants";
import { i18n } from "@framework/localization-ui";

import { themeProps } from "../components/theme";
import { PopupAwareSnackbarProvider } from "./popup-aware-snackbar-provider";
import { SubscribeProvider } from "./subscribe/provider";

export const Providers: FC<PropsWithChildren> = props => {
  const { children } = props;
  return (
    <ApiProviderJwt baseUrl={process.env.BE_URL} storageName={ns}>
      <UserProviderJwt>
        <SettingsProvider defaultLanguage={EnabledLanguages.RU}>
          <ThemeProvider {...themeProps}>
            <LocalizationProvider i18n={i18n} defaultLanguage={EnabledLanguages.RU}>
              <PopupAwareSnackbarProvider>
                <PickerProvider>
                  <AsuProvider>
                    <SubscribeProvider>{children}</SubscribeProvider>
                  </AsuProvider>
                </PickerProvider>
              </PopupAwareSnackbarProvider>
            </LocalizationProvider>
          </ThemeProvider>
        </SettingsProvider>
      </UserProviderJwt>
    </ApiProviderJwt>
  );
};
